import {
    Box,
    Link,
    Typography,
} from "@mui/material";
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import LanguageSelector from "../languageSelector/LanguageSelector";
import { useTranslation } from "react-i18next";

interface FooterProps {
    hasLanguageSelector?: boolean;
}

const Footer = ({ hasLanguageSelector = true }: FooterProps) => {
    const currentYear = new Date().getFullYear();
    const { t } = useTranslation();

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: 2 }}>


            <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                {hasLanguageSelector && <LanguageSelector borderDisabled={true} isUserConnected={false} />}
                <Typography variant="body2" color="text.secondary" align="center" sx={{ marginRight: 'auto' }}>
                    {t("login.footerLogin")}
                    <Link color="inherit" href={t("login.terms")} target="_blank">
                        {t("login.valkartech")}
                    </Link>
                    {currentYear}
                </Typography>
            </Box>

            <Box>
                <Typography variant="body2" color="text.secondary" align="center">
                    <Link href="https://ca.linkedin.com/company/valkartech" target="_blank" sx={{ textDecoration: "none" }}>
                        <LinkedInIcon color="primary" />
                    </Link>
                </Typography>
            </Box>
        </Box>
    );
};

export default Footer;
